import { render, staticRenderFns } from "./ConfigTableSkeletonItem.vue?vue&type=template&id=9d69412a&scoped=true"
import script from "./ConfigTableSkeletonItem.vue?vue&type=script&lang=js"
export * from "./ConfigTableSkeletonItem.vue?vue&type=script&lang=js"
import style0 from "./ConfigTableSkeletonItem.vue?vue&type=style&index=0&id=9d69412a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d69412a",
  null
  
)

export default component.exports